import React, { useEffect, useState } from "react";
import userFallback from "../assets/images/order/delivary-partner.png";
import arrow_right from "../assets/images/navbar/arrow-right.png";
import CustomerRattingCard from "./CustomerRattingCard";
import { restaurantOrderService, restaurantService } from "../services";
import { useRestaurant } from "../context/RestaurantContext";
import { Order } from "../utils/types";
import { getCustomerName, getOrderRating, timeAgo } from "../utils/analytics";

type RatingItem = {
  image: string;
  itemName: string;
  time: string;
  ratting: number;
};

const CustomerRatting = ({ onViewAll }: { onViewAll?: () => void }) => {
  const { restaurantProfile } = useRestaurant();
  const [items, setItems] = useState<RatingItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadRatings = async () => {
      setLoading(true);
      try {
        const restaurantId =
          restaurantProfile?._id || restaurantProfile?.restaurantId;
        if (restaurantId) {
          try {
            const ratingsRes: any = await restaurantService.getRatings(restaurantId);
            const ratings = ratingsRes?.data?.ratings || ratingsRes?.data || [];
            if (Array.isArray(ratings) && ratings.length > 0) {
              setItems(
                ratings.slice(0, 4).map((rating: any) => ({
                  image: rating.user?.image || rating.userImage || userFallback,
                  itemName:
                    rating.userName ||
                    [rating.user?.firstName, rating.user?.lastName]
                      .filter(Boolean)
                      .join(" ") ||
                    "Customer",
                  time: timeAgo(rating.createdAt || rating.updatedAt),
                  ratting: rating.rating || rating.stars || 0,
                }))
              );
              return;
            }
          } catch (error) {
            console.warn("Ratings endpoint unavailable, using delivered orders");
          }
        }

        const response: any = await restaurantOrderService.getOrders({
          page: 1,
          limit: 20,
          orderStatus: "delivered",
        });
        const orders: Order[] = response?.data || [];
        const rated = orders
          .map((order) => ({
            image: order.user?.image || userFallback,
            itemName: getCustomerName(order),
            time: timeAgo(order.deliveredAt || order.updatedAt || order.createdAt),
            ratting: getOrderRating(order),
          }))
          .filter((item) => item.ratting > 0)
          .slice(0, 4);

        setItems(rated);
      } catch (error) {
        console.error("Failed to load customer ratings:", error);
        setItems([]);
      } finally {
        setLoading(false);
      }
    };

    loadRatings();
  }, [restaurantProfile]);

  return (
    <div>
      <div className="mt-8 p-[13px] rounded-[18px] border dark:border-gray-700 bg-white dark:bg-gray-800 transition-colors">
        <div className="flex items-center justify-between pb-[12px] border-b dark:border-gray-700">
          <h5 className="text-[#050505] dark:text-gray-200 font-Urbanist text-[20px] font-medium leading-[20px]">
            Customer Ratings
          </h5>
          <img
            src={arrow_right}
            alt="Arrow Right"
            className={`h-[20px] w-[20px] ${onViewAll ? "cursor-pointer" : ""}`}
            onClick={onViewAll}
          />
        </div>
        {loading ? (
          <div className="flex justify-center py-8">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#FF8A00]"></div>
          </div>
        ) : items.length === 0 ? (
          <p className="text-center text-gray-500 py-8 text-sm">
            No customer ratings yet
          </p>
        ) : (
          items.map((item, index) => (
            <CustomerRattingCard
              key={`${item.itemName}-${index}`}
              image={item.image}
              itemName={item.itemName}
              time={item.time}
              ratting={item.ratting}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default CustomerRatting;
